import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {CfgTaskConfigurationModel} from '../../../models/configuration/cfg-task-configuration.model';
import {CfgTaskConfigurationListModel} from '../../../models/configuration/cfg-task-configuration-list.model';
import {OrganizationDataModel} from '../../../models/organization/organization-data.model';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {CfgARAccountModel} from '../../../models/accountsReceivable/cfg-ar-account.model';

@Injectable({
  providedIn: 'root'
})
export class ARAccountConfigurationService {
  constructor(private http: HttpClient) {
  }

  getAccounts(): Observable<CfgARAccountModel[]> {
    return this.http.get<CfgARAccountModel[]>('/api/ar-account-configuration/get-ar-accounts/');
  }

  saveAccount(account: CfgARAccountModel): Observable<CfgARAccountModel> {
    return this.http.post<CfgARAccountModel>('/api/ar-account-configuration/save-ar-account/', account);
  }

  removeAccount(account: CfgARAccountModel): Observable<CfgARAccountModel> {
    return this.http.post<CfgARAccountModel>('/api/ar-account-configuration/remove-ar-account/', account);
  }
}
